/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminAmenityDto,
  AdminListingBedDto,
  AdminListingDto,
  AdminListingImageDto,
  AdminListingImageUpdateDto,
  AdminListingRequestDto,
  AdminTagDto,
  HostawayLinkRequestDto,
  LandmarkDto,
  ListingBedRequestDto,
  ListingDto,
  OptionDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminListingService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminListingService
   * @name GetListing
   * @summary Get Listing by ID
   * @request GET:/v1/admin/listings/{listingId}
   * @secure
   */
  getListing = (listingId: number, params: RequestParams = {}) =>
    this.http.request<AdminListingDto, any>({
      path: `/v1/admin/listings/${listingId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name UpdateListing
   * @summary Update a Listing
   * @request PUT:/v1/admin/listings/{listingId}
   * @secure
   */
  updateListing = (listingId: number, data: AdminListingRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminListingDto, any>({
      path: `/v1/admin/listings/${listingId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name DeleteListing
   * @summary Delete a Listing
   * @request DELETE:/v1/admin/listings/{listingId}
   * @secure
   */
  deleteListing = (listingId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name UpdateListingImage
   * @summary Update a Image
   * @request PUT:/v1/admin/listings/{listingId}/images/{imageId}
   * @secure
   */
  updateListingImage = (
    listingId: number,
    imageId: number,
    data: AdminListingImageUpdateDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/images/${imageId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name DeleteListingImage
   * @summary Delete a Listing Image
   * @request DELETE:/v1/admin/listings/{listingId}/images/{imageId}
   * @secure
   */
  deleteListingImage = (listingId: number, imageId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/images/${imageId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name ReorderListingImages
   * @summary Reorder Listing Images
   * @request PUT:/v1/admin/listings/{listingId}/images/reorder
   * @secure
   */
  reorderListingImages = (listingId: number, data: number[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/images/reorder`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 숙소와 Hostaway 숙소를 연동합니다. 이미 다른 숙소에서 사용 중인 Hostaway ID는 연동할 수 없습니다.
   *
   * @tags AdminListingService
   * @name SyncHostawayListing
   * @summary Sync Hostaway Listing ID
   * @request PUT:/v1/admin/listings/{listingId}/hostaway
   * @secure
   */
  syncHostawayListing = (
    listingId: number,
    data: HostawayLinkRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/hostaway`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name ReorderListings
   * @summary Reorder Listings
   * @request PUT:/v1/admin/listings/reorder
   * @secure
   */
  reorderListings = (data: number[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/reorder`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name GetListings1
   * @summary Get Listings
   * @request GET:/v1/admin/listings
   * @secure
   */
  getListings1 = (
    query?: {
      searchKeyword?: string;
      /** @format int64 */
      regionId?: number;
      isActive?: boolean;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminListingDto[], any>({
      path: `/v1/admin/listings`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name CreateListing
   * @summary Create a Listing
   * @request POST:/v1/admin/listings
   * @secure
   */
  createListing = (data: AdminListingRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminListingDto, any>({
      path: `/v1/admin/listings`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name GetTagsByListing1
   * @summary Get Tags for a Listing
   * @request GET:/v1/admin/listings/{listingId}/tags
   * @secure
   */
  getTagsByListing1 = (
    listingId: number,
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminTagDto[], any>({
      path: `/v1/admin/listings/${listingId}/tags`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name SaveTags
   * @summary Add Tags to a Listing
   * @request POST:/v1/admin/listings/{listingId}/tags
   * @secure
   */
  saveTags = (listingId: number, data: number[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/tags`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name GetRelatedListings1
   * @summary Get Related Listings
   * @request GET:/v1/admin/listings/{listingId}/relations
   * @secure
   */
  getRelatedListings1 = (listingId: number, params: RequestParams = {}) =>
    this.http.request<ListingDto[], any>({
      path: `/v1/admin/listings/${listingId}/relations`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name SaveRelations
   * @summary Add Relations to a Listing
   * @request POST:/v1/admin/listings/{listingId}/relations
   * @secure
   */
  saveRelations = (listingId: number, data: number[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/relations`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name GetOptionsByListing1
   * @summary Get Options by Listing
   * @request GET:/v1/admin/listings/{listingId}/options
   * @secure
   */
  getOptionsByListing1 = (listingId: number, params: RequestParams = {}) =>
    this.http.request<OptionDto[], any>({
      path: `/v1/admin/listings/${listingId}/options`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name SaveOptions
   * @summary Add Options to a Listing
   * @request POST:/v1/admin/listings/{listingId}/options
   * @secure
   */
  saveOptions = (listingId: number, data: number[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/options`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name GetLandmarksByListing1
   * @summary Get Landmarks for a Listing
   * @request GET:/v1/admin/listings/{listingId}/landmarks
   * @secure
   */
  getLandmarksByListing1 = (
    listingId: number,
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<LandmarkDto[], any>({
      path: `/v1/admin/listings/${listingId}/landmarks`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name SaveLandmarks
   * @summary Add Landmarks to a Listing
   * @request POST:/v1/admin/listings/{listingId}/landmarks
   * @secure
   */
  saveLandmarks = (listingId: number, data: number[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/landmarks`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name GetListingImages
   * @summary Get Images for a Listing
   * @request GET:/v1/admin/listings/{listingId}/images
   * @secure
   */
  getListingImages = (
    listingId: number,
    query?: {
      isPlan?: boolean;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminListingImageDto[], any>({
      path: `/v1/admin/listings/${listingId}/images`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name CreateListingImage
   * @summary Create a Image
   * @request POST:/v1/admin/listings/{listingId}/images
   * @secure
   */
  createListingImage = (
    listingId: number,
    query: {
      isPlan: boolean;
      /** @format int32 */
      seq: number;
    },
    data: {
      /** @format binary */
      file: File;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminListingImageDto, any>({
      path: `/v1/admin/listings/${listingId}/images`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name GetBedTypesByListing1
   * @summary Get Bed-types for a Listing
   * @request GET:/v1/admin/listings/{listingId}/bed-types
   * @secure
   */
  getBedTypesByListing1 = (
    listingId: number,
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminListingBedDto[], any>({
      path: `/v1/admin/listings/${listingId}/bed-types`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description 숙소에 침대 유형을 추가하거나 기존 침대 정보를 갱신합니다.
   *
   * @tags AdminListingService
   * @name SaveBedTypes
   * @summary Add Bed-types to a Listing
   * @request POST:/v1/admin/listings/{listingId}/bed-types
   * @secure
   */
  saveBedTypes = (listingId: number, data: ListingBedRequestDto[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/bed-types`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name GetAmenitiesByListing1
   * @summary Get Amenities for a Listing
   * @request GET:/v1/admin/listings/{listingId}/amenities
   * @secure
   */
  getAmenitiesByListing1 = (
    listingId: number,
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminAmenityDto[], any>({
      path: `/v1/admin/listings/${listingId}/amenities`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminListingService
   * @name SaveAmenities
   * @summary Add Amenities to a Listing
   * @request POST:/v1/admin/listings/{listingId}/amenities
   * @secure
   */
  saveAmenities = (listingId: number, data: number[], params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/listings/${listingId}/amenities`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
